import axios from 'axios';

export async function getCourseList(baseURLs, hashToken) {
  if (!hashToken) {
    throw 'Missing hash token';
  }
  const res = await axios({
    method: 'get',
    baseURL: baseURLs?.API_COURSE_URL,
    url: `/v2/course/preview/similar/${hashToken}`,
    params: {
      tabCategoryId: 1,
      limit: 10,
      offset: 0,
      requiredFilters: '[10]'
    }
  });
  if (res) {
    return res.data;
  }
}
